import SButton from "components/Common/Button"
import React from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  PopoverBody,
  PopoverHeader,
  Row,
  Table,
  UncontrolledPopover,
} from "reactstrap"
import ModalRemarks from "./ModalRemarks"

export default function index({ data }) {
  return (
    <Card>
      <CardBody>
        <Row>
          <Col sm={6}>
            <Row>
              {data?.length
                ? data.map((item, idx) => (
                    <InspectionCard key={idx} idx={idx} data={item} />
                  ))
                : ""}
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export function InspectionCard({ data, idx }) {
  const [isOpen, setIsOpen] = React.useState(false)
  const [selectedInspection, setSelectedInspection] = React.useState(null)
  const [remarks, setRemarks] = React.useState("")
  const toggle = data => {
    setSelectedInspection(data?.id)
    setRemarks(data?.remarks)
    setIsOpen(!isOpen)
  }

  const rows = {
    finishingPress: "仕上げプレス",
    inseamDimension: "股下寸法",
    waistSize: "ウエスト寸法",
    needleDetector: "検針器",
    specificationConfirmation: "仕様確認",
    summaryFestival: "まとめ（まつり）",
    canStopStitch: "カン止め・ステッチ",
    attachButton: "ボタン付け",
    pocketBag: "ミシン縫い①ポケット袋",
    pocketOpeningCloth: "ミシン縫い②ポケット口布",
    brandName: "ブランドネーム",
    qualityEntryConfirmation: "品質記入確認",
    garbage: "糸処理①ごみ",
    hemBasting: "糸処理②裾しつけ",
  }

  console.log(data)

  const getProducer = () => {
    const producer = data.producers.join(", ")
    return producer.length < 14 ? producer : producer.slice(0, 13) + "..."
  }
  return (
    <Col sm={6}>
      <Row>
        <Col sm={12}>
          {data.orderNumber}/{data.companyName}/{data.size}-{data.sequence}
        </Col>
      </Row>
      <Row className="my-3">
        <Col sm={4}>製作者</Col>
        <Col sm={4}>{getProducer()}</Col>
      </Row>
      <Row className="mb-3">
        <Col>検品者名</Col>
        <Col>{data.inspectorName}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm={4}>ステータス</Col>
        <Col sm={4}>{data.status}</Col>
        <Col sm={4}>
          <SButton className="button" onClick={() => toggle(data)}>
            備考
          </SButton>
          <ModalRemarks
            remarks={remarks}
            selectedInspection={selectedInspection}
            isOpen={isOpen}
            toggle={toggle}
          />
          {/* <UncontrolledPopover placement="bottom" target={`button${idx}`}>
            <PopoverHeader className="border border-secondary border-bottom-0 rounded-top">
              備考
            </PopoverHeader>
            <PopoverBody className="border border-secondary border-top-0 rounded-bottom">
              <div className="border border-info rounded p-2 mb-2">
                備考入力欄
              </div>
              <div className="d-flex justify-content-end align-items-end">
                <Button>保存</Button>
              </div>
            </PopoverBody>
          </UncontrolledPopover> */}
        </Col>
      </Row>
      <Table bordered>
        <thead>
          <tr>
            <th style={{ minWidth: 135 }} className="text-center">
              検品項目
            </th>
            <th>製作者</th>
            <th>検品者</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(rows).map(key => (
            <tr key={key}>
              <td>{rows[key]}</td>
              <td>
                <input type="checkbox" checked={data.producer[key]} readOnly />
              </td>
              <td>
                <input type="checkbox" checked={data.inspector[key]} readOnly />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Col>
  )
}
